import { ChangeEvent, MutableRefObject, useRef } from 'react'
import { createPortal } from 'react-dom'

export function useFormPortal(
  formID: string,
  onSubmit: (e: ChangeEvent<HTMLFormElement>) => Promise<void>,
): { formPortal: React.ReactPortal | null; formRef: MutableRefObject<HTMLFormElement | null> } {
  const formRef = useRef<HTMLFormElement>(null)
  const formMountNode = document.getElementById('modal')
  const formPortal = formMountNode
    ? createPortal(<form id={formID} onSubmit={onSubmit} ref={formRef} />, formMountNode)
    : null

  return { formPortal, formRef }
}
